import React from "react";
import { ReportIcon } from "@common/reportIcon";

function ReportTemplateIcon({ className }: { className: string }) {
  return <ReportIcon className={className} />;
}

export { ReportTemplateIcon };
